export default __webpack_public_path__ + "static/media/(11).8b80f52a.jpeg";